export { InsertNewOperation } from './insert-new-operation'
